import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../models/api-url.model';
import { ApiService } from '../../core/services/api';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  private apiService = inject(ApiService);

  createComment(payload: {
    Case__c: string;
    Body__c: string;
  }): Observable<any> {
    const url = `${api.ticketsURL}/${payload.Case__c}${api.commentsURL}`;
    return this.apiService.post(url, payload);
  }

  markCommentsAsRead(payload: { Case__c: string }): Observable<any> {
    const url = `${api.ticketsURL}/${payload.Case__c}${api.commentsURL}/read`;
    return this.apiService.put(url);
  }
}
